import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeProvider';
import { AuthProvider } from './auth/AuthProvider';
import { RequireAuth, SIGN_IN_PATH } from './auth/RequireAuth';
import { SessionProvider } from './auth/session';
import { ApiProvider } from './api/ApiProvider';
import { MeProvider } from './hooks/useMe';
import { AppShell } from './components/AppShell';
import { HomePage } from './pages/HomePage';
import { CustomerPage } from './pages/CustomerPage';
import { CustomerSitePage } from './pages/CustomerSitePage';
import { JobPage } from './pages/JobPage';
import { SupplierPage } from './pages/SupplierPage';
import { DocumentPage } from './pages/DocumentPage';
import { SearchPage } from './pages/SearchPage';
import { BrowsePage } from './pages/BrowsePage';
import { AdminPage } from './pages/AdminPage';
import { AuditPage } from './pages/AuditPage';
import { SignInPage } from './pages/SignInPage';
import { NotFoundPage } from './pages/NotFoundPage';

function Protected() {
  return (
    <RequireAuth>
      <SessionProvider>
        <ApiProvider>
          <MeProvider>
            <AppShell />
          </MeProvider>
        </ApiProvider>
      </SessionProvider>
    </RequireAuth>
  );
}

/** Pages behind sign-in. Shared with the dev-only mock harness (src/mock), which swaps the providers. */
export const protectedRoutes = [
  <Route key="home" index element={<HomePage />} />,
  <Route key="customer" path="customers/:accountNumber" element={<CustomerPage />} />,
  <Route key="customer-site" path="customers/:accountNumber/sites/:partySiteNumber" element={<CustomerSitePage />} />,
  <Route key="job" path="jobs/:siteId" element={<JobPage />} />,
  <Route key="supplier" path="suppliers/:supplierNumber" element={<SupplierPage />} />,
  <Route key="document" path="d/:documentId" element={<DocumentPage />} />,
  <Route key="search" path="search" element={<SearchPage />} />,
  <Route key="browse" path="browse" element={<BrowsePage />} />,
  <Route key="admin" path="admin/*" element={<AdminPage />} />,
  <Route key="audit" path="audit" element={<AuditPage />} />,
  <Route key="index" path="index.html" element={<Navigate to="/" replace />} />,
  <Route key="404" path="*" element={<NotFoundPage />} />,
];

export function AppRoutes() {
  return (
    <Routes>
      <Route path={SIGN_IN_PATH} element={<SignInPage />} />
      <Route element={<Protected />}>{protectedRoutes}</Route>
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
